<template>
  <div class="lineup_singleTeam">
    <div class="lineup_playgroundArea">
      <div class="playgroundArea_bg">
        <span class="topArea">
          <span class="playgroundBg_bigSquare"></span>
          <span class="playgroundBg_semiCircle"></span>
          <span class="playgroundBg_smallSquare"></span>
        </span>
        <span class="centerArea">
          <span class="centerArea_line"></span>
          <span class="centerArea_circle"></span>
          <span class="centerArea_line"></span>
        </span>
        <span class="bottomArea">
          <span class="playgroundBg_bigSquare"></span>
          <span class="playgroundBg_semiCircle"></span>
          <span class="playgroundBg_smallSquare"></span>
        </span>
        <!-- <span
            class="topTeam homeTeam"
            :class="
              lineupType ? `lineupType${lineupType}` : 'lineupType3-3-3-1'
            "
          >
            <span class="player" v-for="i in 11" :key="i">
              <span class="playerNo">
                <i v-text="i"></i>
              </span>
              <span class="playerName">Vlachodimos (GK)</span>
            </span>
            <span class="lineup_type" v-text="lineupType"></span>
          </span>
          <span
            class="bottomTeam awayTeam"
            :class="lineupType ? `lineupType${lineupType}` : 'lineupType4-5-1'"
          >
            <span class="player" v-for="i in 11" :key="i">
              <span class="playerNo">
                <i v-text="i"></i>
              </span>
              <span class="playerName">Vlachodimos (GK)</span>
            </span>
            <span class="lineup_type" v-text="lineupType"></span>
          </span> -->
        <template v-if="lineupMap">
          <span
            v-for="team in lineupMap"
            :key="team.key"
            :class="[
              team.lineupType
                ? `lineupType${team.lineupType}`
                : 'lineupType4-5-1',
              team.key == 'home' ? 'topTeam homeTeam' : 'bottomTeam awayTeam',
            ]"
          >
            <span
              class="player"
              v-for="player in team.list"
              :key="player.playerId"
            >
              <span class="playerNo">
                <i v-text="player.shirtNumber"></i>
              </span>
              <span class="playerName" v-text="player.playerNameWeb"></span>
            </span>
            <span class="lineup_type" v-text="team.lineupType"></span>
          </span>
        </template>

        <!-- 阵容测试dom  -->
        <!-- <span
            v-for="t in 2"
            :key="t"
            :class="[
              'lineupType3-4-3d',
              t == 1 ? 'topTeam homeTeam' : 'bottomTeam awayTeam',
            ]"
          >
            <span class="player" v-for="i in 11" :key="i">
              <span class="playerNo">
                <i v-text="i"></i>
              </span>
              <span class="playerName" v-text="'name'"></span>
            </span>
            <span class="lineup_type" v-text="'3-4-3d'"></span>
          </span> -->
      </div>
    </div>
  </div>
</template>
<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import lineupTypeMap from './lineup_layout.json'
export default {
  name: 'lineup_singleTeam',
  props: {
    datas: {
      type: Object,
      default: null,
    },
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      originLineupMap: [],
      lineupMap: [],
    }
  },
  created() {
    this.originLineupMap = [
      {
        competitionId: 109,
        seasonId: 1039,
        analysisItemId: 'cc286151c190442890ced8e0329cb724',
        analysisItemName: '主队阵型',
        templateId: 1035,
        filterId: 13,
        graphicsId: 24,
        statisticalIds: null,
        haveCdvPackage: false,
        cdvPackageName: '阵型',
        cdvDataGraph: '8',
        limitCount: null,
        seasonOrMatch: true,
        isShow: null,
        themeTemplateType: 2,
        sort: null,
        filterIsNeedShow: false,
        template: {
          templateId: 1035,
          templateName: '主队阵型',
          teamPlayer: 'team',
          sortColumn: null,
          getDataMethod: 'getHomeMatchLineUp',
          getCdvDataMethod: 'getHomeMatchLineUp',
          needPicture: false,
          columnNeedFilter: false,
          needMax: false,
          matchOrSeason: 1,
        },
        filter: {
          filterId: 13,
          filterName: '球员单一',
          filterJson:
            '[{\r\n\t"namech": "球队",\r\n\t"name": "teamId",\r\n\t"values": [],\r\n\t"url": "/args/findTeamIdsByGameId",\r\n\t"dep": [],\r\n\t"clear": ["playerId"],\r\n\t"index": 0\r\n}, {\r\n\t"namech": "球员",\r\n\t"name": "playerId",\r\n\t"values": [],\r\n\t"url": "/args/findPlayerIdsByTeamId",\r\n\t"dep": ["teamId"],\r\n\t"clear": [],\r\n\t"index": 0,\r\n\t"vagueSelect": true\r\n}]',
          filterTypes: [
            {
              nameCh: null,
              name: 'teamId',
              url: '/args/findTeamIdsByGameId',
              dep: [],
              clear: ['playerId'],
              index: 0,
              seasonOrGame: null,
              values: [
                {
                  name: '阿根廷',
                  value: 1020,
                },
                {
                  name: '法国',
                  value: 1008,
                },
              ],
              vagueSelect: false,
            },
            {
              nameCh: null,
              name: 'playerId',
              url: '/args/findPlayerIdsByTeamId',
              dep: ['teamId'],
              clear: [],
              index: 0,
              seasonOrGame: null,
              values: [
                {
                  name: '佛朗哥·阿尔马尼',
                  value: 100710,
                },
                {
                  name: '胡安·福伊特',
                  value: 100679,
                },
                {
                  name: '尼古拉斯·塔利亚菲科',
                  value: 100673,
                },
                {
                  name: '贡萨洛·蒙铁尔',
                  value: 102628,
                },
                {
                  name: '莱安德罗·帕雷德斯',
                  value: 100698,
                },
                {
                  name: '赫尔曼·佩泽拉',
                  value: 100692,
                },
                {
                  name: '罗德里戈·德保罗',
                  value: 102630,
                },
                {
                  name: '马科斯·阿库尼亚',
                  value: 100716,
                },
                {
                  name: '胡利安·阿尔瓦雷斯',
                  value: 102356,
                },
                {
                  name: '利昂内尔·梅西',
                  value: 100704,
                },
                {
                  name: '安赫尔·迪马里亚',
                  value: 100689,
                },
                {
                  name: '赫罗尼莫·鲁利',
                  value: 100668,
                },
                {
                  name: '克里斯蒂安·罗梅罗',
                  value: 102489,
                },
                {
                  name: '埃塞基耶尔·帕拉西奥斯',
                  value: 100684,
                },
                {
                  name: '安赫尔·科雷亚',
                  value: 100683,
                },
                {
                  name: '蒂亚戈·阿尔马达',
                  value: 102631,
                },
                {
                  name: '亚历杭德罗·戈麦斯',
                  value: 100695,
                },
                {
                  name: '吉多·罗德里格斯',
                  value: 100686,
                },
                {
                  name: '尼古拉斯·奥塔门迪',
                  value: 100720,
                },
                {
                  name: '亚历克西斯·麦卡利斯特',
                  value: 102102,
                },
                {
                  name: '保罗·迪巴拉',
                  value: 100696,
                },
                {
                  name: '劳塔罗·马丁内斯',
                  value: 100691,
                },
                {
                  name: '埃米利亚诺·马丁内斯',
                  value: 100672,
                },
                {
                  name: '恩索·费尔南德斯',
                  value: 102629,
                },
                {
                  name: '利桑德罗·马丁内斯',
                  value: 102634,
                },
                {
                  name: '纳韦尔·莫利纳',
                  value: 102638,
                },
              ],
              vagueSelect: true,
            },
          ],
          contrastType: 2,
          contrastName: '单一',
          object: '球员',
          objectType: 'player',
        },
        json: '{"teamId":1020,"playerId":100710}',
        groupType: null,
        useScene: '0',
        actJson: {
          teamId: 1020,
          playerId: 100710,
        },
        renderData: {
          objectInfo: [
            {
              teamName: '阿根廷',
              teamId: 1020,
              teamLogo:
                'https://images.mixtmt.com/hyper/football/team/1020.png',
              teamScore: 0,
              playerInfos: [],
            },
          ],
          templateId: 1035,
          statisticsModels: [
            {
              id: 3365,
              name: '球员照片',
              tableName: null,
              columnName: 'playerLogo',
              type: null,
              sort: 1,
              statisticalEn: 'playerLogo',
              suffix: '',
              isAuto: null,
            },
            {
              id: 3366,
              name: '球员号码',
              tableName: null,
              columnName: 'shirtNumber',
              type: null,
              sort: 2,
              statisticalEn: 'shirtNumber',
              suffix: '',
              isAuto: null,
            },
            {
              id: 3367,
              name: '球员名称',
              tableName: null,
              columnName: 'playerName',
              type: null,
              sort: 3,
              statisticalEn: 'playerName',
              suffix: '',
              isAuto: null,
            },
            {
              id: 3368,
              name: '球员位置x',
              tableName: null,
              columnName: 'x',
              type: null,
              sort: 4,
              statisticalEn: 'x',
              suffix: '',
              isAuto: null,
            },
            {
              id: 3369,
              name: '球员位置y',
              tableName: null,
              columnName: 'y',
              type: null,
              sort: 5,
              statisticalEn: 'y',
              suffix: '',
              isAuto: null,
            },
            {
              id: 3370,
              name: '队长',
              tableName: null,
              columnName: 'isCaptain',
              type: null,
              sort: 6,
              statisticalEn: 'isCaptain',
              suffix: '',
              isAuto: null,
            },
          ],
          analysisItemId: 'cc286151c190442890ced8e0329cb724',
          competitionId: 109,
          seasonId: 1039,
          graphicsId: 24,
          title: '主队阵型',
          data: {
            dataList: [
              {
                shirtNumber: 23,
                playerName: '埃米利亚诺·马丁内斯',
                playerId: 100672,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100672.png',
                formationUsed: '433',
                formationPlace: 1,
                formationShow: '4-3-3',
                x: '1900',
                y: '120',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '埃米利亚诺·马丁内斯',
              },
              {
                shirtNumber: 3,
                playerName: '尼古拉斯·塔利亚菲科',
                playerId: 100673,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100673.png',
                formationUsed: '433',
                formationPlace: 3,
                formationShow: '4-3-3',
                x: '800',
                y: '700',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '尼古拉斯·塔利亚菲科',
              },
              {
                shirtNumber: 19,
                playerName: '尼古拉斯·奥塔门迪',
                playerId: 100720,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100720.png',
                formationUsed: '433',
                formationPlace: 6,
                formationShow: '4-3-3',
                x: '1500',
                y: '600',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '尼古拉斯·奥塔门迪',
              },
              {
                shirtNumber: 13,
                playerName: '克里斯蒂安·罗梅罗',
                playerId: 102489,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102489.png',
                formationUsed: '433',
                formationPlace: 5,
                formationShow: '4-3-3',
                x: '2300',
                y: '600',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '克里斯蒂安·罗梅罗',
              },
              {
                shirtNumber: 26,
                playerName: '纳韦尔·莫利纳',
                playerId: 102638,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102638.png',
                formationUsed: '433',
                formationPlace: 2,
                formationShow: '4-3-3',
                x: '3000',
                y: '700',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '纳韦尔·莫利纳',
              },
              {
                shirtNumber: 20,
                playerName: '亚历克西斯·麦卡利斯特',
                playerId: 102102,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102102.png',
                formationUsed: '433',
                formationPlace: 8,
                formationShow: '4-3-3',
                x: '1200',
                y: '1000',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '亚历克西斯·麦卡利斯特',
              },
              {
                shirtNumber: 24,
                playerName: '恩索·费尔南德斯',
                playerId: 102629,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102629.png',
                formationUsed: '433',
                formationPlace: 4,
                formationShow: '4-3-3',
                x: '1900',
                y: '830',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '恩索·费尔南德斯',
              },
              {
                shirtNumber: 7,
                playerName: '罗德里戈·德保罗',
                playerId: 102630,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102630.png',
                formationUsed: '433',
                formationPlace: 7,
                formationShow: '4-3-3',
                x: '2600',
                y: '1000',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '罗德里戈·德保罗',
              },
              {
                shirtNumber: 11,
                playerName: '安赫尔·迪马里亚',
                playerId: 100689,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100689.png',
                formationUsed: '433',
                formationPlace: 11,
                formationShow: '4-3-3',
                x: '1400',
                y: '1320',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '安赫尔·迪马里亚',
              },
              {
                shirtNumber: 9,
                playerName: '胡利安·阿尔瓦雷斯',
                playerId: 102356,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102356.png',
                formationUsed: '433',
                formationPlace: 9,
                formationShow: '4-3-3',
                x: '2400',
                y: '1320',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '胡利安·阿尔瓦雷斯',
              },
              {
                shirtNumber: 10,
                playerName: '利昂内尔·梅西',
                playerId: 100704,
                teamId: 1020,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100704.png',
                formationUsed: '433',
                formationPlace: 10,
                formationShow: '4-3-3',
                x: '1900',
                y: '1400',
                isCaptain: 1,
                teamLogo: '',
                playerNameWeb: '利昂内尔·梅西',
              },
            ],
          },
          limitCount: null,
          json: null,
          seasonOrMatch: true,
          haveCdvPackage: false,
          needPicture: false,
          needMax: false,
        },
        matchId: '101015',
      },
      {
        competitionId: 109,
        seasonId: 1039,
        analysisItemId: 'c454b93516a849cf95e6ddfaf47cd9b6',
        analysisItemName: '客队阵型',
        templateId: 1036,
        filterId: 13,
        graphicsId: 24,
        statisticalIds: null,
        haveCdvPackage: false,
        cdvPackageName: '阵型',
        cdvDataGraph: '8',
        limitCount: null,
        seasonOrMatch: true,
        isShow: null,
        themeTemplateType: 2,
        sort: null,
        filterIsNeedShow: false,
        template: {
          templateId: 1036,
          templateName: '客队阵型',
          teamPlayer: 'team',
          sortColumn: null,
          getDataMethod: 'getAwayMatchLineUp',
          getCdvDataMethod: 'getAwayMatchLineUp',
          needPicture: false,
          columnNeedFilter: false,
          needMax: false,
          matchOrSeason: 1,
        },
        filter: {
          filterId: 13,
          filterName: '球员单一',
          filterJson:
            '[{\r\n\t"namech": "球队",\r\n\t"name": "teamId",\r\n\t"values": [],\r\n\t"url": "/args/findTeamIdsByGameId",\r\n\t"dep": [],\r\n\t"clear": ["playerId"],\r\n\t"index": 0\r\n}, {\r\n\t"namech": "球员",\r\n\t"name": "playerId",\r\n\t"values": [],\r\n\t"url": "/args/findPlayerIdsByTeamId",\r\n\t"dep": ["teamId"],\r\n\t"clear": [],\r\n\t"index": 0,\r\n\t"vagueSelect": true\r\n}]',
          filterTypes: [
            {
              nameCh: null,
              name: 'teamId',
              url: '/args/findTeamIdsByGameId',
              dep: [],
              clear: ['playerId'],
              index: 0,
              seasonOrGame: null,
              values: [
                {
                  name: '阿根廷',
                  value: 1020,
                },
                {
                  name: '法国',
                  value: 1008,
                },
              ],
              vagueSelect: false,
            },
            {
              nameCh: null,
              name: 'playerId',
              url: '/args/findPlayerIdsByTeamId',
              dep: ['teamId'],
              clear: [],
              index: 0,
              seasonOrGame: null,
              values: [
                {
                  name: '佛朗哥·阿尔马尼',
                  value: 100710,
                },
                {
                  name: '胡安·福伊特',
                  value: 100679,
                },
                {
                  name: '尼古拉斯·塔利亚菲科',
                  value: 100673,
                },
                {
                  name: '贡萨洛·蒙铁尔',
                  value: 102628,
                },
                {
                  name: '莱安德罗·帕雷德斯',
                  value: 100698,
                },
                {
                  name: '赫尔曼·佩泽拉',
                  value: 100692,
                },
                {
                  name: '罗德里戈·德保罗',
                  value: 102630,
                },
                {
                  name: '马科斯·阿库尼亚',
                  value: 100716,
                },
                {
                  name: '胡利安·阿尔瓦雷斯',
                  value: 102356,
                },
                {
                  name: '利昂内尔·梅西',
                  value: 100704,
                },
                {
                  name: '安赫尔·迪马里亚',
                  value: 100689,
                },
                {
                  name: '赫罗尼莫·鲁利',
                  value: 100668,
                },
                {
                  name: '克里斯蒂安·罗梅罗',
                  value: 102489,
                },
                {
                  name: '埃塞基耶尔·帕拉西奥斯',
                  value: 100684,
                },
                {
                  name: '安赫尔·科雷亚',
                  value: 100683,
                },
                {
                  name: '蒂亚戈·阿尔马达',
                  value: 102631,
                },
                {
                  name: '亚历杭德罗·戈麦斯',
                  value: 100695,
                },
                {
                  name: '吉多·罗德里格斯',
                  value: 100686,
                },
                {
                  name: '尼古拉斯·奥塔门迪',
                  value: 100720,
                },
                {
                  name: '亚历克西斯·麦卡利斯特',
                  value: 102102,
                },
                {
                  name: '保罗·迪巴拉',
                  value: 100696,
                },
                {
                  name: '劳塔罗·马丁内斯',
                  value: 100691,
                },
                {
                  name: '埃米利亚诺·马丁内斯',
                  value: 100672,
                },
                {
                  name: '恩索·费尔南德斯',
                  value: 102629,
                },
                {
                  name: '利桑德罗·马丁内斯',
                  value: 102634,
                },
                {
                  name: '纳韦尔·莫利纳',
                  value: 102638,
                },
              ],
              vagueSelect: true,
            },
          ],
          contrastType: 2,
          contrastName: '单一',
          object: '球员',
          objectType: 'player',
        },
        json: '{"teamId":1020,"playerId":100710}',
        groupType: null,
        useScene: '0',
        actJson: {
          teamId: 1020,
          playerId: 100710,
        },
        renderData: {
          objectInfo: [
            {
              teamName: '法国',
              teamId: 1008,
              teamLogo:
                'https://images.mixtmt.com/hyper/football/team/1008.png',
              teamScore: 0,
              playerInfos: [],
            },
          ],
          templateId: 1036,
          statisticsModels: [
            {
              id: 3365,
              name: '球员照片',
              tableName: null,
              columnName: 'playerLogo',
              type: null,
              sort: 1,
              statisticalEn: 'playerLogo',
              suffix: '',
              isAuto: null,
            },
            {
              id: 3366,
              name: '球员号码',
              tableName: null,
              columnName: 'shirtNumber',
              type: null,
              sort: 2,
              statisticalEn: 'shirtNumber',
              suffix: '',
              isAuto: null,
            },
            {
              id: 3367,
              name: '球员名称',
              tableName: null,
              columnName: 'playerName',
              type: null,
              sort: 3,
              statisticalEn: 'playerName',
              suffix: '',
              isAuto: null,
            },
            {
              id: 3368,
              name: '球员位置x',
              tableName: null,
              columnName: 'x',
              type: null,
              sort: 4,
              statisticalEn: 'x',
              suffix: '',
              isAuto: null,
            },
            {
              id: 3369,
              name: '球员位置y',
              tableName: null,
              columnName: 'y',
              type: null,
              sort: 5,
              statisticalEn: 'y',
              suffix: '',
              isAuto: null,
            },
            {
              id: 3370,
              name: '队长',
              tableName: null,
              columnName: 'isCaptain',
              type: null,
              sort: 6,
              statisticalEn: 'isCaptain',
              suffix: '',
              isAuto: null,
            },
          ],
          analysisItemId: 'c454b93516a849cf95e6ddfaf47cd9b6',
          competitionId: 109,
          seasonId: 1039,
          graphicsId: 24,
          title: '客队阵型',
          data: {
            dataList: [
              {
                shirtNumber: 1,
                playerName: '雨果·洛里',
                playerId: 100108,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100108.png',
                formationUsed: '433',
                formationPlace: 1,
                formationShow: '4-3-3',
                x: '1900',
                y: '120',
                isCaptain: 1,
                teamLogo: '',
                playerNameWeb: '雨果·洛里',
              },
              {
                shirtNumber: 22,
                playerName: '特奥·埃尔南德斯',
                playerId: 116257,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/116257.png',
                formationUsed: '433',
                formationPlace: 3,
                formationShow: '4-3-3',
                x: '800',
                y: '700',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '特奥·埃尔南德斯',
              },
              {
                shirtNumber: 18,
                playerName: '达约·乌帕梅卡诺',
                playerId: 102801,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102801.png',
                formationUsed: '433',
                formationPlace: 6,
                formationShow: '4-3-3',
                x: '1500',
                y: '600',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '达约·乌帕梅卡诺',
              },
              {
                shirtNumber: 4,
                playerName: '拉斐尔·瓦拉内',
                playerId: 100087,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100087.png',
                formationUsed: '433',
                formationPlace: 5,
                formationShow: '4-3-3',
                x: '2300',
                y: '600',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '拉斐尔·瓦拉内',
              },
              {
                shirtNumber: 5,
                playerName: '朱尔·昆代',
                playerId: 100101,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100101.png',
                formationUsed: '433',
                formationPlace: 2,
                formationShow: '4-3-3',
                x: '3000',
                y: '700',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '朱尔·昆代',
              },
              {
                shirtNumber: 14,
                playerName: '阿德里安·拉比奥',
                playerId: 100086,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100086.png',
                formationUsed: '433',
                formationPlace: 8,
                formationShow: '4-3-3',
                x: '1200',
                y: '1000',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '阿德里安·拉比奥',
              },
              {
                shirtNumber: 8,
                playerName: '奥雷利安·楚阿梅尼',
                playerId: 102794,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102794.png',
                formationUsed: '433',
                formationPlace: 4,
                formationShow: '4-3-3',
                x: '1900',
                y: '830',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '奥雷利安·楚阿梅尼',
              },
              {
                shirtNumber: 7,
                playerName: '安托万·格里茨曼',
                playerId: 100093,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100093.png',
                formationUsed: '433',
                formationPlace: 7,
                formationShow: '4-3-3',
                x: '2600',
                y: '1000',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '安托万·格里茨曼',
              },
              {
                shirtNumber: 10,
                playerName: '基利安·姆巴佩',
                playerId: 100091,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100091.png',
                formationUsed: '433',
                formationPlace: 11,
                formationShow: '4-3-3',
                x: '1400',
                y: '1320',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '基利安·姆巴佩',
              },
              {
                shirtNumber: 9,
                playerName: '奥利维耶·吉鲁',
                playerId: 100090,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100090.png',
                formationUsed: '433',
                formationPlace: 9,
                formationShow: '4-3-3',
                x: '2400',
                y: '1320',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '奥利维耶·吉鲁',
              },
              {
                shirtNumber: 11,
                playerName: '奥斯曼·登贝莱',
                playerId: 100100,
                teamId: 1008,
                playerLogo:
                  'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100100.png',
                formationUsed: '433',
                formationPlace: 10,
                formationShow: '4-3-3',
                x: '1900',
                y: '1400',
                isCaptain: 0,
                teamLogo: '',
                playerNameWeb: '奥斯曼·登贝莱',
              },
            ],
          },
          limitCount: null,
          json: null,
          seasonOrMatch: true,
          haveCdvPackage: false,
          needPicture: false,
          needMax: false,
        },
        matchId: '101015',
      },
    ]
    let lineupMap = []
    if (this.originLineupMap) {
      // 有数据才走逻辑，防止报错
      this.originLineupMap.forEach((themeItem, index) => {
        const teamRow =
          themeItem.renderData && themeItem.renderData.data.dataList
            ? themeItem.renderData.data.dataList
            : []
        const lineupType =
          teamRow[0] && teamRow[0].formationUsed
            ? formatLineup(teamRow[0].formationUsed)
            : ''
        console.debug('lineupMap:', lineupType)
        if (lineupType) {
          lineupMap.push({
            lineupType,
            list: teamRow.map((player) => {
              let playerNameWeb = player.playerName
              if (player.position) {
                playerNameWeb += `(${player.position})`
              }
              player.playerNameWeb = playerNameWeb
              return player
            }),
            key: index == 0 ? 'home' : 'away',
          })
        }
      })
      console.debug('lineupMap:', lineupMap)
      const curLineupTypeMap = lineupTypeMap[this.dataOrigin]
      this.lineupMap = lineupMap.map((team) => {
        let lineupSort = curLineupTypeMap[team.lineupType]
        const newList = lineupSort.map((index) => {
          let item = null

          for (let i = 0; i < team.list.length; i++) {
            const player = team.list[i]
            if (player.formationPlace == index) {
              item = player
              break
            }
          }
          return item
        })
        return {
          lineupType: team.lineupType,
          list: newList,
          key: team.key,
        }
      })
    }
    function formatLineup(formationUsed) {
      let lineupType = ''
      if (!formationUsed) {
        return lineupType
      }
      if (formationUsed.indexOf('d') > -1) {
        lineupType = '3-4-3d'
      } else {
        let arr = []
        for (let i = 0; i < formationUsed.length; i++) {
          arr.push(formationUsed[i])
        }
        lineupType = arr.join('-')
      }
      return lineupType
    }
    console.debug(this.lineupMap)
  },
}
</script>
<style lang="scss" scoped>
.lineup_playgroundArea {
  margin: 0 0.694vw;
  width: calc(100% - 51.4vw - 1.388vw);
  .playgroundArea_bg {
    position: relative;
    width: 100%;
    padding-top: 209.25%;
    background-color: var(--mixtmt_lineup_footBallPlaygroundColor);
    & .topArea {
      .playgroundBg_bigSquare,
      .playgroundBg_smallSquare {
        top: 0;
        border-top: none;
      }
      .playgroundBg_semiCircle {
        top: 11.25%;
      }
    }
    & .bottomArea {
      .playgroundBg_bigSquare,
      .playgroundBg_smallSquare {
        bottom: 0;
        border-bottom: none;
      }
      .playgroundBg_semiCircle {
        bottom: 11.25%;
      }
    }
    .playgroundBg_bigSquare {
      position: absolute;
      left: 17.5%;
      z-index: 20;
      width: 65%;
      padding-top: 32%;
      background-color: var(--mixtmt_lineup_footBallPlaygroundColor);
      border: 1px solid var(--mixtmt_greyColor9);
    }
    .playgroundBg_semiCircle {
      position: absolute;
      left: 40%;
      z-index: 10;
      width: 20%;
      padding-top: 13%;
      border: 1px solid var(--mixtmt_greyColor9);
      border-radius: 50%;
    }
    .playgroundBg_smallSquare {
      position: absolute;
      left: 32.75%;
      z-index: 30;
      width: 34.5%;
      padding-top: 17%;
      border: 1px solid var(--mixtmt_greyColor9);
    }

    & .centerArea {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 50;
      width: 100%;
      height: auto;
      transform: translate(-50%, -50%);
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      .centerArea_line {
        width: 27.25%;
        height: 1px;
        background-color: var(--mixtmt_greyColor9);
      }
      .centerArea_circle {
        position: relative;
        width: 45%;
        padding-top: 45%;
        border: 1px solid var(--mixtmt_greyColor9);
        border-radius: 50%;
        &::before {
          content: '\20';
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 55;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 1px;
          background-color: var(--mixtmt_greyColor9);
        }
        &::after {
          content: '\20';
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 55;
          transform: translate(-50%, -50%);
          width: 6.66%;
          padding-top: 6.66%;
          background-color: var(--mixtmt_greyColor9);
          border-radius: 50%;
        }
      }
    }
    .theme_publishBtn {
      position: absolute;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 3.2vw;
      height: 3.2vw;
      opacity: 0.7;
      svg.publishBtn_icon {
        fill: var(--mixtmt_whiteColor);
      }
      &.home {
        top: 0;
        right: 0;
      }
      &.away {
        bottom: 0;
        left: 0;
      }
      &.allPlayerScore {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        top: -3.19vw;
        left: 0;
        width: 3.19vw;
        height: 3.19vw;
        svg.publishBtn_icon {
          fill: var(--mixtmt_blackColor);
        }
      }
    }

    .lineup_type {
      position: absolute;
      z-index: 60;
      font-size: 1.388vw;
      color: var(--mixtmt_whiteColor);
    }

    .player {
      position: absolute;
      z-index: 66;
      display: block;
      width: 12.5%;
      .playerNo {
        display: block;
        position: relative;
        padding-top: 80%;
        width: 100%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        i {
          display: block;
          position: absolute;
          top: 50%;
          left: 0;
          z-index: 70;
          transform: translateY(-50%);
          width: 100%;
          font-size: 1.11vw;
          color: var(--mixtmt_whiteColor);
          text-align: center;
        }
      }
      .playerName {
        display: -webkit-box;
        width: 160%;
        height: 2.778vw;
        margin-left: -30%;
        color: var(--mixtmt_whiteColor);
        text-align: center;
        overflow: hidden;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        /* overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap; */
      }
    }
    /* 上半场布局是自上到下，自左到右；下半场布局是自下到上，自左到右 */
    & .topTeam {
      .lineup_type {
        top: 0;
        left: 0;
        padding: 3% 0 0 3%;
      }
      &.lineupType4-4-2 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 15%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 15%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 15%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 15%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 27%;
            left: 8.25%;
          }
          &:nth-child(7) {
            top: 27%;
            left: 32%;
          }
          &:nth-child(8) {
            top: 27%;
            right: 32%;
          }
          &:nth-child(9) {
            top: 27%;
            right: 8.25%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType4-3-3 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 15%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 15%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 15%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 15%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 27%;
            left: 12%;
          }
          &:nth-child(7) {
            top: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 27%;
            right: 12%;
          }
          &:nth-child(9) {
            top: 39%;
            left: 12%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            top: 39%;
            right: 12%;
          }
        }
      }
      &.lineupType4-5-1 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 13%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 13%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 13%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 13%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 32%;
            left: 6%;
          }
          &:nth-child(7) {
            top: 23.5%;
            left: 20%;
          }
          &:nth-child(8) {
            top: 23.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            top: 23.5%;
            right: 20%;
          }
          &:nth-child(10) {
            top: 32%;
            right: 6%;
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType5-3-2 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 12%;
            left: 3.25%;
          }
          &:nth-child(3) {
            top: 14%;
            left: 23.25%;
          }
          &:nth-child(4) {
            top: 16%;
            left: 43.25%;
          }
          &:nth-child(5) {
            top: 14%;
            right: 23.25%;
          }
          &:nth-child(6) {
            top: 12%;
            right: 3.25%;
          }
          &:nth-child(7) {
            top: 27%;
            left: 14%;
          }
          &:nth-child(8) {
            top: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            top: 27%;
            right: 14%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType5-4-1 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 12%;
            left: 3.25%;
          }
          &:nth-child(3) {
            top: 14%;
            left: 23.25%;
          }
          &:nth-child(4) {
            top: 16%;
            left: 43.25%;
          }
          &:nth-child(5) {
            top: 14%;
            right: 23.25%;
          }
          &:nth-child(6) {
            top: 12%;
            right: 3.25%;
          }
          &:nth-child(7) {
            top: 27%;
            left: 8.25%;
          }
          &:nth-child(8) {
            top: 27%;
            left: 32%;
          }
          &:nth-child(9) {
            top: 27%;
            right: 32%;
          }
          &:nth-child(10) {
            top: 27%;
            right: 8.25%;
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-5-2 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 15%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 15%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 15%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 30%;
            left: 3.25%;
          }
          &:nth-child(6) {
            top: 26%;
            left: 20%;
          }
          &:nth-child(7) {
            top: 26%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 26%;
            right: 20%;
          }
          &:nth-child(9) {
            top: 30%;
            right: 3.25%;
          }

          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType3-4-3 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 15%;
            left: 20%;
          }
          &:nth-child(3) {
            top: 15%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 15%;
            right: 20%;
          }
          &:nth-child(5) {
            top: 27%;
            left: 8.25%;
          }
          &:nth-child(6) {
            top: 27%;
            left: 32%;
          }
          &:nth-child(7) {
            top: 27%;
            right: 32%;
          }
          &:nth-child(8) {
            top: 27%;
            right: 8.25%;
          }
          &:nth-child(9) {
            top: 39%;
            left: 12%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            top: 39%;
            right: 12%;
          }
        }
      }
      &.lineupType3-4-3d {
        .player {
          &:first-child {
            top: 1%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 20%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 11%;
            right: 20%;
          }
          &:nth-child(5) {
            top: 20.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            top: 26%;
            left: 10%;
          }
          &:nth-child(7) {
            top: 26%;
            right: 10%;
          }
          &:nth-child(8) {
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            top: 39.5%;
            left: 12%;
          }
          &:nth-child(10) {
            top: 39.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            top: 39.5%;
            right: 12%;
          }
        }
      }
      &.lineupType4-2-4-0 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 15%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 15%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 15%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 15%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 27%;
            left: 26%;
          }
          &:nth-child(7) {
            top: 27%;
            right: 26%;
          }
          &:nth-child(8) {
            top: 39%;
            left: 8.25%;
          }
          &:nth-child(9) {
            top: 39%;
            left: 32%;
          }
          &:nth-child(10) {
            top: 39%;
            right: 32%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 8.25%;
          }
        }
      }
      &.lineupType4-4-1-1 {
        .player {
          &:first-child {
            top: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 21%;
            left: 8.25%;
          }
          &:nth-child(7) {
            top: 21%;
            left: 32%;
          }
          &:nth-child(8) {
            top: 21%;
            right: 32%;
          }
          &:nth-child(9) {
            top: 21%;
            right: 8.25%;
          }
          &:nth-child(10) {
            top: 29%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-1-4-1 {
        .player {
          &:first-child {
            top: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            top: 29%;
            left: 8.25%;
          }
          &:nth-child(8) {
            top: 29%;
            left: 32%;
          }
          &:nth-child(9) {
            top: 29%;
            right: 32%;
          }
          &:nth-child(10) {
            top: 29%;
            right: 8.25%;
          }

          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-2-3-1 {
        .player {
          &:first-child {
            top: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 20.5%;
            left: 27%;
          }
          &:nth-child(7) {
            top: 20.5%;
            right: 27%;
          }
          &:nth-child(8) {
            top: 29%;
            left: 14%;
          }
          &:nth-child(9) {
            top: 29%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 29%;
            right: 14%;
          }

          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-3-2-1 {
        .player {
          &:first-child {
            top: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }

          &:nth-child(6) {
            top: 21%;
            left: 14%;
          }
          &:nth-child(7) {
            top: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 21%;
            right: 14%;
          }
          &:nth-child(9) {
            top: 30%;
            left: 27%;
          }
          &:nth-child(10) {
            top: 30%;
            right: 27%;
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-2-2-2 {
        .player {
          &:first-child {
            top: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 21%;
            left: 23%;
          }
          &:nth-child(7) {
            top: 21%;
            right: 23%;
          }
          &:nth-child(8) {
            top: 30%;
            left: 32%;
          }
          &:nth-child(9) {
            top: 30%;
            right: 32%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 23%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 23%;
          }
        }
      }
      &.lineupType3-5-1-1 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 11%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 24%;
            left: 3.25%;
          }
          &:nth-child(6) {
            top: 21%;
            left: 20%;
          }
          &:nth-child(7) {
            top: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 21%;
            right: 20%;
          }
          &:nth-child(9) {
            top: 24%;
            right: 3.25%;
          }

          &:nth-child(10) {
            top: 31%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            top: 40%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-4-2-1 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 12%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 12%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 22%;
            left: 8.25%;
          }
          &:nth-child(6) {
            top: 22%;
            left: 32%;
          }
          &:nth-child(7) {
            top: 22%;
            right: 32%;
          }
          &:nth-child(8) {
            top: 22%;
            right: 8.25%;
          }
          &:nth-child(9) {
            top: 32%;
            left: 26%;
          }
          &:nth-child(10) {
            top: 32%;
            right: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-4-1-2 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 12%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 12%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 22%;
            left: 8.25%;
          }
          &:nth-child(6) {
            top: 22%;
            left: 32%;
          }
          &:nth-child(7) {
            top: 22%;
            right: 32%;
          }
          &:nth-child(8) {
            top: 22%;
            right: 8.25%;
          }
          &:nth-child(9) {
            top: 32%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType3-1-4-2 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11.5%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 11.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 11.5%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            top: 29%;
            left: 8.25%;
          }
          &:nth-child(7) {
            top: 29%;
            left: 32%;
          }
          &:nth-child(8) {
            top: 29%;
            right: 32%;
          }
          &:nth-child(9) {
            top: 29%;
            right: 8.25%;
          }

          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType4-1-3-2 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11.5%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11.5%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11.5%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11.5%;
            right: 8.25%;
          }

          &:nth-child(6) {
            top: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            top: 30%;
            left: 14%;
          }
          &:nth-child(8) {
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            top: 30%;
            right: 14%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType4-3-1-2 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11.5%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11.5%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11.5%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11.5%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 21%;
            left: 14%;
          }
          &:nth-child(7) {
            top: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 21%;
            right: 14%;
          }
          &:nth-child(9) {
            top: 31%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType3-2-4-1 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 12%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 12%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 20.5%;
            left: 26%;
          }
          &:nth-child(6) {
            top: 20.5%;
            right: 26%;
          }
          &:nth-child(7) {
            top: 30.5%;
            left: 8.25%;
          }
          &:nth-child(8) {
            top: 30.5%;
            left: 32%;
          }
          &:nth-child(9) {
            top: 30.5%;
            right: 32%;
          }
          &:nth-child(10) {
            top: 30.5%;
            right: 8.25%;
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-3-3-1 {
        .player {
          &:first-child {
            top: 0.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 10%;
            left: 16%;
          }
          &:nth-child(3) {
            top: 10%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 10%;
            right: 16%;
          }
          &:nth-child(5) {
            top: 20%;
            left: 16%;
          }
          &:nth-child(6) {
            top: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            top: 20%;
            right: 16%;
          }
          &:nth-child(8) {
            top: 30%;
            left: 6%;
          }
          &:nth-child(9) {
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 30%;
            right: 6%;
          }
          &:nth-child(11) {
            top: 39.5%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-1-2-1-2 {
        .player {
          &:first-child {
            top: 1%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            top: 25%;
            left: 12%;
          }
          &:nth-child(8) {
            top: 25%;
            right: 12%;
          }
          &:nth-child(9) {
            top: 32%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 40%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 40%;
            right: 26%;
          }
        }
      }
      &.lineupType3-1-3-1-2 {
        .player {
          &:first-child {
            top: 0.3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 9%;
            left: 20%;
          }
          &:nth-child(3) {
            top: 9%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 9%;
            right: 20%;
          }
          &:nth-child(5) {
            top: 18%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            top: 27%;
            left: 6%;
          }
          &:nth-child(7) {
            top: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 27%;
            right: 6%;
          }
          &:nth-child(9) {
            top: 36%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 40.5%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 40.5%;
            right: 26%;
          }
        }
      }
    }
    & .bottomTeam {
      .lineup_type {
        bottom: 0;
        right: 0;
        padding: 0 3% 3% 0;
      }

      &.lineupType4-4-2 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 15%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 15%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 15%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 15%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 27%;
            right: 8.25%;
          }
          &:nth-child(7) {
            bottom: 27%;
            right: 32%;
          }
          &:nth-child(8) {
            bottom: 27%;
            left: 32%;
          }
          &:nth-child(9) {
            bottom: 27%;
            left: 8.25%;
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType4-3-3 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 15%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 15%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 15%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 15%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 27%;
            right: 12%;
          }
          &:nth-child(7) {
            bottom: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 27%;
            left: 12%;
          }
          &:nth-child(9) {
            bottom: 39%;
            right: 12%;
          }
          &:nth-child(10) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 12%;
          }
        }
      }
      &.lineupType4-5-1 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 13%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 13%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 13%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 13%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 32%;
            right: 6%;
          }
          &:nth-child(7) {
            bottom: 23.5%;
            right: 20%;
          }
          &:nth-child(8) {
            bottom: 23.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            bottom: 23.5%;
            left: 20%;
          }
          &:nth-child(10) {
            bottom: 32%;
            left: 6%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType5-3-2 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 12%;
            right: 3.25%;
          }
          &:nth-child(3) {
            bottom: 14%;
            right: 23.25%;
          }
          &:nth-child(4) {
            bottom: 16%;
            left: 43.25%;
          }
          &:nth-child(5) {
            bottom: 14%;
            left: 23.25%;
          }
          &:nth-child(6) {
            bottom: 12%;
            left: 3.25%;
          }
          &:nth-child(7) {
            bottom: 27%;
            right: 14%;
          }
          &:nth-child(8) {
            bottom: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            bottom: 27%;
            left: 14%;
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType5-4-1 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 12%;
            right: 3.25%;
          }
          &:nth-child(3) {
            bottom: 14%;
            right: 23.25%;
          }
          &:nth-child(4) {
            bottom: 16%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(5) {
            bottom: 14%;
            left: 23.25%;
          }
          &:nth-child(6) {
            bottom: 12%;
            left: 3.25%;
          }
          &:nth-child(7) {
            bottom: 27%;
            right: 8.25%;
          }
          &:nth-child(8) {
            bottom: 27%;
            right: 32%;
          }
          &:nth-child(9) {
            bottom: 27%;
            left: 32%;
          }
          &:nth-child(10) {
            bottom: 27%;
            left: 8.25%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-5-2 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 15%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 15%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 15%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 30%;
            right: 3.25%;
          }
          &:nth-child(6) {
            bottom: 26%;
            right: 20%;
          }
          &:nth-child(7) {
            bottom: 26%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 26%;
            left: 20%;
          }
          &:nth-child(9) {
            bottom: 30%;
            left: 3.25%;
          }

          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType3-4-3 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 15%;
            right: 20%;
          }
          &:nth-child(3) {
            bottom: 15%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 15%;
            left: 20%;
          }
          &:nth-child(5) {
            bottom: 27%;
            right: 8.25%;
          }
          &:nth-child(6) {
            bottom: 27%;
            right: 32%;
          }
          &:nth-child(7) {
            bottom: 27%;
            left: 32%;
          }
          &:nth-child(8) {
            bottom: 27%;
            left: 8.25%;
          }
          &:nth-child(9) {
            bottom: 39%;
            right: 12%;
          }
          &:nth-child(10) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 12%;
          }
        }
      }
      &.lineupType3-4-3d {
        .player {
          &:first-child {
            bottom: 1%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 20%;
          }
          &:nth-child(3) {
            bottom: 11%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 20%;
          }
          &:nth-child(5) {
            bottom: 20.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            bottom: 26%;
            right: 10%;
          }
          &:nth-child(7) {
            bottom: 26%;
            left: 10%;
          }
          &:nth-child(8) {
            bottom: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            bottom: 39.5%;
            right: 12%;
          }
          &:nth-child(10) {
            bottom: 39.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            bottom: 39.5%;
            left: 12%;
          }
        }
      }
      &.lineupType4-2-4-0 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 15%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 15%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 15%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 15%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 27%;
            right: 26%;
          }
          &:nth-child(7) {
            bottom: 27%;
            left: 26%;
          }
          &:nth-child(8) {
            bottom: 39%;
            right: 8.25%;
          }
          &:nth-child(9) {
            bottom: 39%;
            right: 32%;
          }
          &:nth-child(10) {
            bottom: 39%;
            left: 32%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 8.25%;
          }
        }
      }
      &.lineupType4-4-1-1 {
        .player {
          &:first-child {
            bottom: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 21%;
            right: 8.25%;
          }
          &:nth-child(7) {
            bottom: 21%;
            right: 32%;
          }
          &:nth-child(8) {
            bottom: 21%;
            left: 32%;
          }
          &:nth-child(9) {
            bottom: 21%;
            left: 8.25%;
          }
          &:nth-child(10) {
            bottom: 29%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-1-4-1 {
        .player {
          &:first-child {
            bottom: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            bottom: 29%;
            right: 8.25%;
          }
          &:nth-child(8) {
            bottom: 29%;
            right: 32%;
          }
          &:nth-child(9) {
            bottom: 29%;
            left: 32%;
          }
          &:nth-child(10) {
            bottom: 29%;
            left: 8.25%;
          }

          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-2-3-1 {
        .player {
          &:first-child {
            bottom: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 20.5%;
            right: 27%;
          }
          &:nth-child(7) {
            bottom: 20.5%;
            left: 27%;
          }
          &:nth-child(8) {
            bottom: 29%;
            right: 14%;
          }
          &:nth-child(9) {
            bottom: 29%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 29%;
            left: 14%;
          }

          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-3-2-1 {
        .player {
          &:first-child {
            bottom: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }

          &:nth-child(6) {
            bottom: 21%;
            right: 14%;
          }
          &:nth-child(7) {
            bottom: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 21%;
            left: 14%;
          }
          &:nth-child(9) {
            bottom: 30%;
            right: 27%;
          }
          &:nth-child(10) {
            bottom: 30%;
            left: 27%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-2-2-2 {
        .player {
          &:first-child {
            bottom: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 21%;
            right: 23%;
          }
          &:nth-child(7) {
            bottom: 21%;
            left: 23%;
          }
          &:nth-child(8) {
            bottom: 30%;
            right: 32%;
          }
          &:nth-child(9) {
            bottom: 30%;
            left: 32%;
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 23%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 23%;
          }
        }
      }
      &.lineupType3-5-1-1 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 11%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 24%;
            right: 3.25%;
          }
          &:nth-child(6) {
            bottom: 21%;
            right: 20%;
          }
          &:nth-child(7) {
            bottom: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 21%;
            left: 20%;
          }
          &:nth-child(9) {
            bottom: 24%;
            left: 3.25%;
          }

          &:nth-child(10) {
            bottom: 31%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            bottom: 40%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-4-2-1 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 12%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 12%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 22%;
            right: 8.25%;
          }
          &:nth-child(6) {
            bottom: 22%;
            right: 32%;
          }
          &:nth-child(7) {
            bottom: 22%;
            left: 32%;
          }
          &:nth-child(8) {
            bottom: 22%;
            left: 8.25%;
          }
          &:nth-child(9) {
            bottom: 32%;
            right: 26%;
          }
          &:nth-child(10) {
            bottom: 32%;
            left: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-4-1-2 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 12%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 12%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 22%;
            right: 8.25%;
          }
          &:nth-child(6) {
            bottom: 22%;
            right: 32%;
          }
          &:nth-child(7) {
            bottom: 22%;
            left: 32%;
          }
          &:nth-child(8) {
            bottom: 22%;
            left: 8.25%;
          }
          &:nth-child(9) {
            bottom: 32%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType3-1-4-2 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11.5%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 11.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 11.5%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            bottom: 29%;
            right: 8.25%;
          }
          &:nth-child(7) {
            bottom: 29%;
            right: 32%;
          }
          &:nth-child(8) {
            bottom: 29%;
            left: 32%;
          }
          &:nth-child(9) {
            bottom: 29%;
            left: 8.25%;
          }

          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType4-1-3-2 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11.5%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11.5%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11.5%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11.5%;
            left: 8.25%;
          }

          &:nth-child(6) {
            bottom: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            bottom: 30%;
            right: 14%;
          }
          &:nth-child(8) {
            bottom: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            bottom: 30%;
            left: 14%;
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType4-3-1-2 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11.5%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11.5%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11.5%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11.5%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 21%;
            right: 14%;
          }
          &:nth-child(7) {
            bottom: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 21%;
            left: 14%;
          }
          &:nth-child(9) {
            bottom: 31%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType3-2-4-1 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 12%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 12%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 20.5%;
            right: 26%;
          }
          &:nth-child(6) {
            bottom: 20.5%;
            left: 26%;
          }
          &:nth-child(7) {
            bottom: 30.5%;
            right: 8.25%;
          }
          &:nth-child(8) {
            bottom: 30.5%;
            right: 32%;
          }
          &:nth-child(9) {
            bottom: 30.5%;
            left: 32%;
          }
          &:nth-child(10) {
            bottom: 30.5%;
            left: 8.25%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-3-3-1 {
        .player {
          &:first-child {
            bottom: 0.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 10%;
            right: 16%;
          }
          &:nth-child(3) {
            bottom: 10%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 10%;
            left: 16%;
          }
          &:nth-child(5) {
            bottom: 20%;
            right: 16%;
          }
          &:nth-child(6) {
            bottom: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            bottom: 20%;
            left: 16%;
          }
          &:nth-child(8) {
            bottom: 30%;
            right: 6%;
          }
          &:nth-child(9) {
            bottom: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 30%;
            left: 6%;
          }
          &:nth-child(11) {
            bottom: 39.5%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-1-2-1-2 {
        .player {
          &:first-child {
            bottom: 1%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            bottom: 25%;
            right: 12%;
          }
          &:nth-child(8) {
            bottom: 25%;
            left: 12%;
          }
          &:nth-child(9) {
            bottom: 32%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 40%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 40%;
            left: 26%;
          }
        }
      }
      &.lineupType3-1-3-1-2 {
        .player {
          &:first-child {
            bottom: 0.3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 9%;
            right: 20%;
          }
          &:nth-child(3) {
            bottom: 9%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 9%;
            left: 20%;
          }
          &:nth-child(5) {
            bottom: 18%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            bottom: 27%;
            right: 6%;
          }
          &:nth-child(7) {
            bottom: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 27%;
            left: 6%;
          }
          &:nth-child(9) {
            bottom: 36%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 40.5%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 40.5%;
            left: 26%;
          }
        }
      }
    }

    & .homeTeam {
      .playerNo {
        background-image: var(--mixtmt_homePlayerNo_bg);
      }
    }
    & .awayTeam {
      .playerNo {
        background-image: var(--mixtmt_awayPlayerNo_bg);
      }
    }
  }
}
</style>
